// Generated by ts-to-zod
import { z } from 'zod';
import { idSchema, urlSchema } from '../../utils/codecUtils.schema';

export const engineUseCaseSchema = z.union([
  z.literal('generic_ap'),
  z.literal('coupa_line_level'),
  z.literal('coupa_header_level'),
]);

export const engineSettingsSchema = z.object({
  useCase: engineUseCaseSchema,
});

export const engineSchema = z.object({
  id: idSchema,
  url: urlSchema,
  name: z.string(),
  description: z.string().optional(),
  type: z.union([z.literal('extractor'), z.literal('splitter')]),
  learningEnabled: z.boolean(),
  agendaId: z.string(),
  trainingQueues: z.array(urlSchema),
  settings: engineSettingsSchema,
});
